<script setup></script>

<template>
  <svg
    viewBox="0 0 13 14"
    fill="none"
    class=""
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="5.5" r="4.5" stroke="#061F5F" />
    <line
      x1="8.35355"
      y1="9.14645"
      x2="12.3536"
      y2="13.1464"
      stroke="#061F5F"
    />
  </svg>
</template>

<style scoped></style>
